module.exports = __webpack_public_path__ + "img/compare_fingerprints_splash.c0f7290b.jpg";